// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"248fe138","394":"83109ab5","474":"be819dfc","499":"d23a1beb","668":"308d4a21","729":"aad3ab53"}[chunkId] + ".css";
};